import { ILeadFormModel } from '@user/components/Leads/AddLeadForm/typings'
import { addLeadNote } from '@user/components/Settings/EntityFormSettings/constants'
import { selectAllEntityFormSettings } from '@user/store/entityFormSettings'
import { useGetFieldActiveStates } from '@user/store/entityFormSettings/hooks/useGetFieldActiveStates'
import { useFormikContext } from 'formik'
import { useSelector } from 'react-redux'

type Props = {
  hideOptional: boolean
}

export function useData(props: Props) {
  const { hideOptional } = props

  const settings = useSelector(selectAllEntityFormSettings)
  const entitySettingsMap = useGetFieldActiveStates(settings, hideOptional)

  const [requiredAddNote, showAddNote] = entitySettingsMap.get(addLeadNote) ?? [
    false,
    true,
  ]

  const { errors, touched, values, setFieldValue } =
    useFormikContext<ILeadFormModel>()

  return {
    errors,
    requiredAddNote,
    showAddNote,
    touched,
    values,
    setFieldValue,
  }
}
